import { componentProvider } from 'js-component-framework';
import getFormattedClassnames from 'utils/getFormattedClassnames';
import TopicsMegaMenu from './topics-megamenu';
import './dropdown-all-topics.scss';
import './dropdown-single-topic.scss';

const menuClassnames = sciencenewsClassnames['topics-megamenu'];
const menuSelectors = getFormattedClassnames(menuClassnames);
const dropdownSingleClassnames = sciencenewsClassnames['dropdown-single-topic'];
// eslint-disable-next-line max-len
const dropdownSingleSelectors = getFormattedClassnames(dropdownSingleClassnames);

const topicsMegaMenuConfig = {
  name: 'topics-menu',
  component: TopicsMegaMenu,
  querySelector: {
    list: menuSelectors.list,
  },
  querySelectorAll: {
    singleDropdownLists: `${dropdownSingleSelectors.dropdown}`,
  },
  options: {
    selectors: {
      articleList: dropdownSingleSelectors.articleList,
    },
  },
};

componentProvider(topicsMegaMenuConfig);
